export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f78d0b3f4d9231e3acf1b9711e85994f916a466ff&name=fetchTypeahead!'